import { FC } from 'react';
import useMessageStore, {
  EMessageStatus,
  EContentType,
  useGetMediaList,
} from '@/store/messageStore';
import PreviewContent from './PreviewContent';
import useAppStore from '@/store/appStore';
import MobMediaPreview from './MobMediaPreview';
import PcMediaPreview from './PcMediaPreview';

const MediaPreview: FC<{}> = () => {
  const messageStore = useMessageStore();
  const videoPlayerRefs = useRef<any[]>([]);
  const { mediaList } = useGetMediaList();
  const swiperRef = useRef<any>();
  const appStore = useAppStore();

  useEffect(() => {
    swiperRef.current?.swiperRef?.handleSlide?.(messageStore.activePreviewMediaInx);
  }, [messageStore.activePreviewMediaInx]);

  if (appStore.curDevice === 'phone') {
    return (
      <MobMediaPreview show={messageStore.showPreviewMedia}>
        <PreviewContent showTool mediaList={mediaList} ref={swiperRef} />
      </MobMediaPreview>
    );
  }

  return (
    <PcMediaPreview show={messageStore.showPreviewMedia}>
      <PreviewContent showTool={false} mediaList={mediaList} ref={swiperRef} />

      <img
        src={require('@img/common/icon-slides-arrow.svg')}
        alt=""
        className="z-2 cursor-pointer absolute left-48 left top-[50%] transform w-80 slide-arrow"
      />
      <img
        src={require('@img/common/icon-slides-arrow.svg')}
        alt=""
        className="z-2 cursor-pointer absolute right-48 right top-[50%] transform rotate-180 slide-arrow"
      />
    </PcMediaPreview>
  );
};

export default MediaPreview;
